<ng-container *ngIf="error; else resultTpl">
  <nz-result nzStatus="error" nzTitle="Teamcenter gave an error" [nzSubTitle]="error"></nz-result>
</ng-container>

<ng-template #resultTpl>
  <nz-tabs
    class="em-tabs-vertical"
    nzTabPosition="left"
    nzSize="large"
    *ngIf="elementDesignStructure"
  >
    <nz-tab
      *ngFor="let tab of elementDesignStructure?.revisions; trackBy: trackByRef"
      [nzTitle]="tab.revId"
    >
      <nz-descriptions nzBordered nzLayout="vertical">
        <nz-descriptions-item nzTitle="Datasets" nzSpan="3">
          <em-dataset-card-list [datasets]="tab.datasets"></em-dataset-card-list>
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-tab>
  </nz-tabs>
</ng-template>
